<template>
  <div class="impressum-container p-5">
    <h2 class="mb-4">Impressum / Legal Notice</h2>
    
    <b-card class="mb-4 text-left">
      <b-card-header>Technical Administrator</b-card-header>
      <b-card-body>
        <p>Simeon Wetzel</p>
        <p>Helmholtzstraße 10</p>
        <p>01069 Dresden</p>
      </b-card-body>
    </b-card>

    <b-card class="mb-4 text-left">
      <b-card-header>Contact</b-card-header>
      <b-card-body>
        <p>Phone: +49 (0) 351 463 32634</p>
        <p>Email: simeon.wetzel [at] tu-dresden.de</p>
      </b-card-body>
    </b-card>

    <b-card class="text-left">
      <b-card-header>Disclaimer</b-card-header>
      <b-card-body>
        <p><strong>Accountability for content</strong><br>
        Find more information on our <a href="https://klimakonform.uw.tu-dresden.de/">project website</a> (only available in German)</p>
      </b-card-body>
    </b-card>
    
  </div>
</template>

<script>
export default {
  name: 'LegalNotice',
};
</script>

<style scoped>
.impressum-container {
  max-width: 900px;
  margin: 0 auto;
  text-align: center;
}
.card-header {
    font-weight: bold;
    background-color: var(--card-background-color);
    color: var(--text-color);
}
.card {
    background-color: var(--card-background-color);
    color: var(--text-color);
    border-color: var(--border-color);
}
</style>